import { ExtendedRawConsumptionProperties } from '@store';
import { DcTypes, FeatureNames, GetResponse, RawHemsHistoricalData } from '@vi-iot/client';
import moment from 'moment';

export class EnergyHistoricalDataMappers {
  static mapLegacyHPResponse(
    response: GetResponse<RawHemsHistoricalData>[]
  ): ExtendedRawConsumptionProperties[] {
    const featureName = FeatureNames.legacyHeatPumpConsumption;
    let dayRaw;
    let weekRaw;
    let monthRaw;
    let yearRaw;

    if (response.length === 1) {
      const mappedDays: [number, string][][] = response.map((timeRange) => {
        return timeRange?.data.data.timeseries
          .reverse()
          .map((record) => [
            Number(record[featureName]),
            moment(record.timestamp).format('YYYY-MM-DD'),
          ]);
      });

      const days = 8;
      const lastXDays: string[] = [];

      lastXDays.push(moment().format('YYYY-MM-DD'));

      for (let i = 1; i < days; i++) {
        lastXDays.push(moment().clone().subtract(i, 'days').format('YYYY-MM-DD'));
      }

      dayRaw = lastXDays.map((dayDate) => {
        const matchedDay = mappedDays[0].find((singleDay: [number, string]) => {
          return singleDay[1] === dayDate;
        });

        const value = matchedDay ? matchedDay[0] : 0;

        return value;
      });
    } else {
      [weekRaw, monthRaw, yearRaw] = response.map((timeRange) => {
        return timeRange?.data.data.timeseries
          .reverse()
          .map((record) => Number(record[featureName]));
      });
    }

    return [
      {
        day: { value: validateDataForChart(8, dayRaw), type: DcTypes.array },
        week: { value: validateDataForChart(13, weekRaw), type: DcTypes.array },
        month: { value: validateDataForChart(13, monthRaw), type: DcTypes.array },
        year: { value: validateDataForChart(3, yearRaw), type: DcTypes.array },
        unit: {
          value: response[0]?.data.timeseries_properties[featureName] ?? '',
          type: DcTypes.string,
        },
        color: 'vi-pending-07',
        designationKey: 'FEATURE.HEATING.POWER.CONSUMPTION.TOTAL',
      },
    ];
  }
}

function validateDataForChart(expectedRecordsNumber: number, data: Array<number>): Array<number> {
  if (!data) {
    return [];
  }

  const dataLength = data.length;

  if (dataLength === expectedRecordsNumber) {
    return data;
  } else {
    const lengthDiff = expectedRecordsNumber - dataLength;
    const arr = Array<number>(lengthDiff).fill(0);

    return data.concat(arr);
  }
}
